import React, { ReactElement, useEffect } from 'react';
import {
  withAppInsightsTracking,
  appInsights
} from '@exxonmobil/uit-uda-ui-components-lib';

import styles from './Incrementals.module.scss';

const renderIncrementals = () => {
  return (
    <div className={styles.page}>
      <h1>Incrementals main page</h1>
    </div>
  );
};

const IncrementalsComponent = React.memo((): ReactElement => {
  useEffect(() => {
    document.title = 'AION // Incrementals';
    appInsights.trackPageView({ name: 'Incrementals' });
  }, []);

  return renderIncrementals();
});

export const Incrementals = withAppInsightsTracking(IncrementalsComponent);
